module.exports = __webpack_public_path__ + "static/img/oa01.74bfdab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/oa01.png
// module id = QvBD
// module chunks = 1